<template>
  <div v-if="showActions" class="page-header__nav-item dropdown" :class="addClasses">
    <a href="javascript:void(0)" aria-haspopup="true" aria-expanded="false" :title="getTranslation('actions')" data-toggle="dropdown">
                                                <span class="page-header__icon-wrap">
                                                    <svg class="page-header__nav-icon" style="transform: rotate(90deg);">
                                                        <use xlink:href="#icon__more-horizontal"></use>
                                                    </svg>
                                                </span>
    </a>
    <div class="dropdown-menu options__dropdown dropdown-menu-right">
      <div class="mydropdown">
        <div class="mydropdown__group">
          <ul class="mydropdown__list-items">
            <li v-if="hasEdit" class="mydropdown__item">
              <a class="mydropdown__link" @click="()=>{$emit('edit')}" href="javascript:void(0)">{{ getTranslation('edit') }}</a>
            </li>
            <li v-if="hasDelete" class="mydropdown__item">
              <a class="mydropdown__link" @click="()=>{$emit('delete')}" href="javascript:void(0)">{{ getTranslation('delete') }}</a>
            </li>
            <li v-if="hasPassword" class="mydropdown__item">
              <a class="mydropdown__link" @click="()=>{$emit('password')}" href="javascript:void(0)">{{ getTranslation('generatePassword') }}</a>
            </li>

            <li v-if="options.rejectRetake" class="mydropdown__item">
              <a class="mydropdown__link" @click="()=>{$emit('rejectRetake')}" href="javascript:void(0)">{{ getTranslation('rejectRetake') }}</a>
            </li>
            <li v-if="options.cancelEvent" class="mydropdown__item">
              <a class="mydropdown__link" @click="()=>{$emit('cancelEvent')}" href="javascript:void(0)">{{ getTranslation('cancelEvent') }}</a>
            </li>
            <li v-if="options.detailedResults" class="mydropdown__item">
              <a class="mydropdown__link" @click="()=>{$emit('detailedResults')}" href="javascript:void(0)">{{ getTranslation('candiateDetailedResults') }}</a>
            </li>
            <li v-if="options.deactivate" class="mydropdown__item">
              <a class="mydropdown__link" @click="()=>{$emit('deactivate')}" href="javascript:void(0)">{{ getTranslation('deactivate') }}</a>
            </li>
            <li v-if="options.activate" class="mydropdown__item">
              <a class="mydropdown__link" @click="()=>{$emit('activate')}" href="javascript:void(0)">{{ getTranslation('activate') }}</a>
            </li>
            <li v-if="options.registrationList" class="mydropdown__item">
              <a class="mydropdown__link" @click="()=>{$emit('registrationList','.docx')}" href="javascript:void(0)">{{ getTranslation('registrationList_format', '(.docx)') }}</a>
            </li>
            <li v-if="options.registrationList" class="mydropdown__item">
              <a class="mydropdown__link" @click="()=>{$emit('registrationList','.pdf')}" href="javascript:void(0)">{{ getTranslation('registrationList_format', '(.pdf)') }}</a>
            </li>
            <li v-if="options.tokenList" class="mydropdown__item">
              <a class="mydropdown__link" @click="()=>{$emit('tokenList','.docx')}" href="javascript:void(0)">{{ getTranslation('generateTokenList_format', '(.docx)') }}</a>
            </li>
            <li v-if="options.tokenList" class="mydropdown__item">
              <a class="mydropdown__link" @click="()=>{$emit('tokenList','.pdf')}" href="javascript:void(0)">{{ getTranslation('generateTokenList_format', '(.pdf)') }}</a>
            </li>
            <li v-if="options.viewPage" class="mydropdown__item">
              <a class="mydropdown__link" @click="()=>{$emit('viewPage')}" href="javascript:void(0)">{{ getTranslation('viewPage') }}</a>
            </li>
            <li v-if="options.notifyCandidate" class="mydropdown__item">
              <a class="mydropdown__link" @click="()=>{$emit('notifyCandidate')}" href="javascript:void(0)">{{ getTranslation('notifyCandidate') }}</a>
            </li>
            <li v-if="options.notifyTestingDate" class="mydropdown__item">
              <a class="mydropdown__link" @click="()=>{$emit('notifyTestingDate')}" href="javascript:void(0)">{{ getTranslation('notifyAboutTestingDate') }}</a>
            </li>
            <li v-if="options.notifyTestingCancel" class="mydropdown__item">
              <a class="mydropdown__link" @click="()=>{$emit('notifyTestingCancel')}" href="javascript:void(0)">{{ getTranslation('notifyAboutTestingCancel') }}</a>
            </li>
            <li v-if="options.cancelResult" class="mydropdown__item">
              <a class="mydropdown__link" @click="()=>{$emit('cancelResult')}" href="javascript:void(0)">{{ getTranslation('cancelResults') }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ActionsComponent",
  props: {
    hasEdit: {
      type: Boolean,
      default: true
    },
    hasDelete: {
      type: Boolean,
      default: true,
    },
    hasPassword: {
      type: Boolean,
      default: false,
    },
    addClasses:String,
    options: {
      type: Object,
      default: () => {
        return {
          cancelEvent: false,
        }
      }
    }
  },
  computed: {
    showActions() {
      if (this.hasEdit || this.hasDelete || this.hasPassword)
        return true;

      if (this.options)
        for (let option in this.options)
          if (this.options.hasOwnProperty(option) && this.options[option])
            return true;

      return false;
    }
  }
}
</script>

<style scoped>
.options__dropdown {
  width: 220px;
}
</style>
